// client/src/components/SiteInstructionPublicPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { siteInstructionPublicAPI } from '../utils/api';

export default function SiteInstructionPublicPage() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    siteInstructionPublicAPI.getMeta(token)
      .then(r => { setMeta(r.data); setState(r.data.state); })
      .catch(e => setState(e.response?.status === 404 ? 'invalid' : 'error'));
  }, [token]);

  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const resp = await fetch(siteInstructionPublicAPI.downloadUrl(token));
      if (resp.status === 409) {
        setState('rehydrating');
        return;
      }
      if (!resp.ok) {
        setState('error');
        return;
      }
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const cd = resp.headers.get('content-disposition') || '';
      const match = cd.match(/filename="?([^"]+)"?/);
      a.download = match ? match[1] : `Site-Instruction-${token}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setState('error');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
      <div className="card bg-white p-8 rounded-lg shadow max-w-md w-full text-center">
        <img src="/logo.png" alt="TCS Insight" style={{ height: 40, margin: '0 auto 16px' }} />
        {state === 'loading' && <p>Loading…</p>}
        {state === 'invalid' && <p className="text-slate-600">This link is not valid.</p>}
        {state === 'error' && <p className="text-slate-600">Something went wrong. Please try again later.</p>}
        {state === 'superseded' && <p className="text-slate-600">This Site Instruction has been superseded by a newer one. Please contact MPAMOT for the current version.</p>}
        {state === 'rehydrating' && <p className="text-slate-600">This document is being retrieved from cold storage — this can take a few hours. Please try again later.</p>}
        {state === 'ready' && meta && (
          <>
            <h2 className="text-lg font-semibold mb-1">Site Instruction</h2>
            <p className="text-slate-600 text-sm mb-1">Station {meta.station_no}{meta.reference ? ` · ${meta.reference}` : ''}</p>
            <p className="text-slate-400 text-xs mb-4">Issued {new Date(meta.issued_at).toLocaleDateString('en-ZA')}</p>
            <button
              className="btn btn-primary inline-block"
              onClick={handleDownload}
            >
              Download Site Instruction (PDF)
            </button>
            <p className="text-slate-400 text-xs mt-4">This is an official Site Instruction issued via TCS Insight.</p>
          </>
        )}
      </div>
    </div>
  );
}
